$(document).ready(function () {
  //setTimeout(function () {

  $(".itg_map_slider .map_main").owlCarousel({
    items: 1,
    loop: true,
    margin: 10,
    dots: true,
    dotsData: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
  });
  //}, 500);

  /*home page gallery section slider*/
  $(".itg_collection_gallery .owl-carousel").owlCarousel({
    autoplay: true,
    lazyLoad: true,
    loop: true,
    items: 1,
    margin: 20,
    /*
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  */
    responsiveClass: true,
    autoplayTimeout: 7000,
    smartSpeed: 800,
    nav: true,
    dots: false,
  });
  /*collection prouct slider on home page*/
  $(".itg_collection_slider .owl-carousel").owlCarousel({
    lazyLoad: true,
    loop: false,
    margin: 20,
    /*
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  */
    responsiveClass: true,
    smartSpeed: 800,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },

      600: {
        items: 1,
      },

      1024: {
        items: 2,
      },

      1366: {
        items: 3,
      },
    },
  });

  $(document).on('click','.bundle_add_btn',function() {
    var variant_id = $(this).data('value');
    //alert(variant_id);
    var data = {
      "id": variant_id,
      "quantity": "1"
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        // window.location.href = '/cart';
        
      }
    });
  })

  
});

document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});
